'use strict';

import toastsTemplate from './toasts.directive.html';
import './toasts.directive.scss';

export default angular
  .module('maestro.directives.semantic.toast', [])

  .directive('smToasts', function() {
    return {
      restrict: 'E',
      scope: {},
      template: toastsTemplate,
      controller: ($scope, $element, $timeout, $log, ToastsService) => {
        $scope.toastsInternal = [];
        $scope.toastsService = ToastsService;

        angular.extend($scope, {
          onCloseToastButtonClick: onCloseToastButtonClick,
          onToastClick: onToastClick
        });

        init();

        function init() {
          $scope.$watch('toastsService.toasts', () => {
            processToastsUpdate(ToastsService.toasts);
          }, true);
        }

        function processToastsUpdate() {
          // process animations
          let externalToasts = ToastsService.toasts;
          let internalToasts = $scope.toastsInternal;

          if (!externalToasts) {
            $scope.toastsInternal = [];
            return;
          }

          let newToasts = externalToasts.filter(tExt => !internalToasts.some((tInt => tInt.id === tExt.id)));
          let removedToasts = internalToasts.filter(tExt => !externalToasts.some((tInt => tInt.id === tExt.id)));

          removedToasts.forEach(removedToast => {
            if (!removedToast.removing) {
              removedToast.removing = true;
              let toastEl = $($element).find(`#${removedToast.id}`);
              toastEl.removeClass('appearing');
              toastEl.addClass('removing');
              toastEl.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
                toastEl.css('display', 'none');
                $scope.$applyAsync(() => {
                  $scope.toastsInternal = $scope.toastsInternal.filter(t => t.id !== removedToast.id);
                });
              });
            }
          });

          newToasts.forEach(newToast => {
            newToast = angular.copy(newToast);
            internalToasts.push(newToast);
            if (newToast.timeout > 0) { // if newToast.timeout === 0 - show instantly
              newToast.timeoutPromise = $timeout(() => {
                ToastsService.toasts = ToastsService.toasts.filter(t => t.id !== newToast.id);
                if (newToast.onClose) {
                  try {
                    newToast.onClose();
                  } catch (err) {
                    $log.warn(err);
                  }
                }
              }, newToast.timeout);
            }
          });
        }

        function onCloseToastButtonClick(toast, $event) {
          if ($event && $event.stopPropagation) {
            $event.stopPropagation();
          }
          if (!toast) {
            return;
          }
          ToastsService.toasts = ToastsService.toasts.filter(t => t.id !== toast.id);
          // remove instantly
          $scope.toastsInternal = $scope.toastsInternal.filter(t => t.id !== toast.id);

          if (toast.onClose) {
            try {
              toast.onClose();
            } catch (err) {
              $log.warn(err);
            }
          }
        }

        function onToastClick(toast, $event) {
          if ($event && $event.stopPropagation) {
            $event.stopPropagation();
          }
          if (!toast) {
            return;
          }
          if (toast.timeoutPromise) {
            $timeout.cancel(toast.timeoutPromise); // Cancel auto-close timeout
            toast.timeoutPromise = void 0;
            toast.forceClosable = true;
          }
          if (toast.onClick) {
            toast.forceClosable = false;
            try {
              toast.onClick();
            } catch (err) {
              $log.warn(err);
            }

            // remove toast instantly
            ToastsService.toasts = ToastsService.toasts.filter(t => t.id !== toast.id);
            $scope.toastsInternal = $scope.toastsInternal.filter(t => t.id !== toast.id);
          }
        }
      }
    };
  })

  .service('ToastsService', function ToastsService($filter) {
    let $t = $filter('translate');

    const DEFAULT_TIMEOUT = 5000;
    const DEFAULT_CLASS_NAME = 'basic';
    const TOAST_TYPES = {
      success: {
        className: 'success',
        timeout: 5000,
        icon: 'fal fa-check-circle'
      },
      info: {
        className: 'blue',
        timeout: 5000,
        icon: 'fal fa-info-circle'
      },
      warning: {
        className: 'yellow',
        timeout: 10000,
        icon: 'fal fa-exclamation-circle'
      },
      error: {
        className: 'error',
        timeout: 10000,
        icon: 'fal fa-times-circle'
      }
    };
    const AVAILABLE_CLASS_NAMES = [
      'basic',
      'success',
      'info',
      'warning',
      'error',
      'red',
      'orange',
      'yellow',
      'olive',
      'green',
      'teal',
      'blue',
      'violet',
      'purple',
      'pink',
      'brown',
      'black'
    ];

    let idIndex = 0;
    let me = this;

    angular.extend(this, {
      show: show,
      success: success,
      info: info,
      warning: warning,
      error: error,
      closeAll: closeAll,
      custom: custom,
      toasts: []
    });

    /**
     * Show toast message
     * @param {string} title Title of the message
     * @param {string} message Text of the message
     * @param {string} type Type of the message - success, info, warning or error.
     *     You can also use colors here: red, orange, yellow, olive, green,
     *     teal, blue, violet, purple, pink, brown or black
     */
    function show(title, message, type) {
      title = title || '';
      message = message || '';

      if (!title && !message) {
        if (type === 'success') {
          title = $t('common.saved-success');
        } else if (type === 'error') {
          title = $t('errors.something');
        } else {
          return;
        }
      }
      let predefinedType = TOAST_TYPES[type];

      let className = (predefinedType && predefinedType.className && AVAILABLE_CLASS_NAMES.includes(predefinedType.className))
        ? predefinedType.className
        : DEFAULT_CLASS_NAME;

      let timeout = predefinedType ? predefinedType.timeout : DEFAULT_TIMEOUT;

      let icon = predefinedType ? predefinedType.icon : void 0;

      if (idIndex >= Number.MAX_SAFE_INTEGER) { // ha ha
        idIndex = 0;
      }

      me.toasts.push({
        id: idIndex++, // unique identifier
        title: title, // Toast title
        message: message, // Toast message
        className: className, // Class name
        timeout: timeout, // Toast timeout,
        icon: icon // Toast icon
      });
    }

    /**
     * Show custom toast
     * @param config
     * @param {string} config.title title
     * @param {string} config.message message
     * @param {string} [config.className]
     * @param {number} [config.timeout]
     * @param {string} [config.icon]
     * @param [config.onClick] on click callback
     * @param [config.onClose] on close callback
     * @param [config.closable] show/hide close icon
     */
    function custom(config) {
      let cfg = {
        id: idIndex++, // unique identifier
        className: DEFAULT_CLASS_NAME, // Class name
        timeout: DEFAULT_TIMEOUT, // Toast timeout,
        ...config
      };

      me.toasts.push(cfg);
    }

    function success(title, message) {
      return show(title, message, 'success');
    }

    function info(title, message) {
      return show(title, message, 'info');
    }

    function warning(title, message) {
      return show(title, message, 'warning');
    }

    function error(title, message) {
      return show(title, message, 'error');
    }

    function closeAll() {
      me.toasts?.forEach(toast => {
        if (toast.onClose) {
          try {
            toast.onClose();
          } catch (err) {
            $log.warn(err);
          }
        }
      });
      me.toasts = [];
    }
  })

  .name;
